module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Flower#1-d98fdd0980822dbb1e9e99f6b9d23a045589a442adc5904dc0b3369d9de7abbe.svg";